import { render, staticRenderFns } from "./ActiveFiltersCard.vue?vue&type=template&id=5e15ff6d"
import script from "./ActiveFiltersCard.vue?vue&type=script&lang=js"
export * from "./ActiveFiltersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports